import EditCar from '@/components/edit-car';

export default EditCar;
